module.exports = __webpack_public_path__ + "img/21.7121766c.png";